import { useEffect, useRef } from 'react'
import { useSetRecoilState, useRecoilValue } from 'recoil'
import {
    formulaSheetEntriesAtom,
    formulaSheetEntriesInvalidatorAtom,
    lastSavedFormulaSheetEntriesAtom,
} from '@/atoms/formulaSheetEntries'

export const useInitializeLastSavedFormulaSheetEntries = (): void => {
    const formulaSheetEntries = useRecoilValue(formulaSheetEntriesAtom)
    const invalidator = useRecoilValue(formulaSheetEntriesInvalidatorAtom)
    const setLastSavedFormulaSheetEntries = useSetRecoilState(
        lastSavedFormulaSheetEntriesAtom
    )
    const initializedInvalidatorRef = useRef<number | null>(null)
    useEffect(() => {
        if (initializedInvalidatorRef.current === invalidator) return
        initializedInvalidatorRef.current = invalidator
        setLastSavedFormulaSheetEntries(formulaSheetEntries)
    }, [formulaSheetEntries, invalidator, setLastSavedFormulaSheetEntries])
}
